import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Address Blacklist',
    id: 'RQv7n+',
    description: 'Title for address blacklist card',
  },
  description: {
    defaultMessage: 'Blocks orders shipping to addresses on your blacklist. Useful for known fraud addresses and high-risk locations.',
    id: 'lQdcGL',
    description: 'Description of address blacklist fraud detection',
  },
  fuzzyMatchingLabel: {
    defaultMessage: 'Enable fuzzy address matching',
    id: '76CLxX',
    description: 'Label for fuzzy matching toggle',
  },
  fuzzyMatchingHelp: {
    defaultMessage: 'Catches variations like "123 Main St" vs "123 Main Street"',
    id: 'qa0Iof',
    description: 'Help text for fuzzy matching',
  },
  manageBlacklistButton: {
    defaultMessage: 'Manage Blacklist',
    id: '57sqWM',
    description: 'Button text to navigate to blacklist management',
  },
  fuzzyFlagThresholdLabel: {
    defaultMessage: 'Flag orders at',
    id: '0gQm5r',
    description: 'Label for fuzzy flag threshold input',
  },
  fuzzyBlockThresholdLabel: {
    defaultMessage: 'Block orders at',
    id: 'QDpPfP',
    description: 'Label for fuzzy block threshold input',
  },
  matchOrHigher: {
    defaultMessage: '% match or higher',
    id: 'MnkzOQ',
    description: 'Suffix text for threshold inputs',
  },
  thresholdGapError: {
    defaultMessage: 'Block threshold must be at least 5% higher than flag threshold',
    id: 'Jz+fMs',
    description: 'Error message when fuzzy matching thresholds are too close together',
  },
});
